var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-page"},[_c('div',{staticClass:"m-info-box"},[_vm._m(0),_c('div',{staticClass:"m-des"},[_vm._v("\n      "+_vm._s(_vm.obj.examineComment||'无')+"\n    ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-info-tit"},[_c('img',{attrs:{"src":require("@/assets/img/home/Group787.png"),"alt":""}}),_c('span',[_vm._v("审核意见")])])
}]

export { render, staticRenderFns }